import { PushConnection } from '@/models/push'
import { ActiveUser } from '@/models/user'
import { CricketMatch } from '@/models/cricket/match'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

let cricketFirebaseConnection = null

export class CricketFirebaseConnection extends PushConnection {
  _listenToRecentMatches () {

  }

  buildPushConnection (token) {
    const config = {
      apiKey: 'AIzaSyCWIu2iwKLSnH2JpXp3knD_jyPwWpb-e6w',
      authDomain: 'cricket-api-admin.firebaseapp.com',
      databaseURL: 'https://cricket-api-admin.firebaseio.com',
      projectId: 'cricket-api-admin',
      storageBucket: 'cricket-api-admin.appspot.com',
      messagingSenderId: '486889371533'
    }
    let pushConnection = null
    try {
      pushConnection = firebase.app()
    } catch (err) {
      if (err.code && err.code === 'app/no-app') {
        // using cached app
      } else {
        console.log('Error while getting app instance', err)
      }
    }
    if (!pushConnection) {
      pushConnection = firebase.initializeApp(config)
    }
    const user = ActiveUser.user
    this._fbInit = false

    if (!user.firebaseToken) {
      console.log('Firebase Token missing')
      return pushConnection
    }

    this._fbInit = true
    const fbuser = firebase.auth().currentUser
    if (fbuser) {
      this.onAuthenticated()
      this._listenToRecentMatches()
    } else {
      firebase.auth().signInWithCustomToken(user.firebaseToken).then(() => {
        console.log('Firebase Auth Done')
        this.onAuthenticated()
        this._listenToRecentMatches()
      }).catch((err) => {
        console.log('Firebase Auth ERROR', err)
      })
    }

    return pushConnection
  }

  getMatchPath (key) {
    return `roanuz-cricket/recent-matches/${key}`
  }

  getMatchRef (key) {
    return firebase.database().ref(this.getMatchPath(key))
  }

  connectMatch (key) {
    super.connectMatch(key)
    console.debug('Firebase Listen Match', key)
    this.getMatchRef(key).on('value', (snapshot) => {
      const raw = snapshot.val()
      // console.log(`Got Match update for ${key}`)
      if (raw) {
        const match = CricketMatch.createFromJson(raw)
        this.onMatchUpdate(match.key, match)
      }
    }, (err) => {
      console.log(`Error listening to ${key}`, err)
    })
  }

  removeMatch (key) {
    this.getMatchRef(key).off('value')
  }
}

export const CricketFirebase = {
  instance () {
    if (cricketFirebaseConnection == null) {
      cricketFirebaseConnection = new CricketFirebaseConnection()
    }
    return cricketFirebaseConnection
  }
}
